/** Sets <html lang> from saved user prefs (BCP 47 primary subtag or ISO 639-1). Client-only. */
export function syncDocumentLangFromUserPrefs(
  language: string | null | undefined,
  locale: string | null | undefined,
) {
  if (!import.meta.client) return
  const fromLocale = locale?.trim().split('-')[0]
  const fromLang = language?.trim()
  const primary = fromLocale || fromLang
  if (primary) {
    document.documentElement.lang = primary
  }
}
